import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const StatusCircle = ({
  precentage = 30,
  color = "rgb(179, 179, 179)",
  title = "title",
}) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <div
        style={{
          position: "relative",
          width: 80,
          height: 80,
          backgroundColor: "white",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid rgb(179, 179, 179)",
        }}
        title={title}
      >
        <div
          style={{
            position: "absolute",
            width: 65,
            height: 65,
            background: `conic-gradient(${color} ${
              precentage ?? 0
            }%, rgb(179, 179, 179) ${precentage ?? 0}%)`,
            borderRadius: "50%",
          }}
        ></div>
        <div
          style={{
            zIndex: 555,
            width: 50,
            height: 50,
            backgroundColor: "white",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 35,
              height: 35,
              backgroundColor: 'white',
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black",
              fontSize: 17,
              fontWeight:'bold'
            }}
          >
            <div className="mt-1">
              {getDir(getCurrentLangFromRedux()) == "rtl" ? "%" : ""}
              {precentage ?? 0}
              {getDir(getCurrentLangFromRedux()) == "ltr" ? "%" : ""}
            </div>
          </div>
        </div>
      </div>
      <div className="text-center pt-1">{title}</div>
    </div>
  );
};

export default StatusCircle;
